var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-layout"},[_c('Header',{attrs:{"layout":_vm.layout}},[_vm._t("header")],2),_c('main',{staticClass:"main"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }